import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';
import { withDefaultSort } from '../../utils/utility';

export const ACTION = {
  LIST: 'LIST_AC_CENTRAL',
  GET: 'GET_AC_CENTRAL',
  CREATE: 'CREATE_AC_CENTRAL',
  EDIT: 'EDIT_AC_CENTRAL',
  DELETE: 'DELETE_AC_CENTRAL',
  DUPLICATE: 'DUPLICATE_AC_CENTRAL',
  CLEAR_ERROR: 'CLEAR_ERROR_AC_CENTRAL',
  ADD_CHILLER: 'ADD_CHILLER_TO_AC_CENTRAL',
  ADD_TO_BE_CREATED_CHILLER: 'ADD_TO_BE_CREATED_CHILLER',
  EDIT_CHILLER: 'EDIT_CHILLER_TO_AC_CENTRAL',
  EDIT_TO_BE_CREATED_CHILLER: 'EDIT_TO_BE_CREATED_CHILLER',
  REMOVE_CHILLER: 'REMOVE_CHILLER_TO_AC_CENTRAL',
  REMOVE_TO_BE_CREATED_CHILLER: 'REMOVE_TO_BE_CREATED_CHILLER',
  ADD_WATER_PUMP: 'ADD_WATER_PUMP_TO_AC_CENTRAL',
  ADD_TO_BE_CREATED_WATER_PUMP: 'ADD_TO_BE_CREATED_WATER_PUMP',
  EDIT_TO_BE_CREATED_WATER_PUMP: 'EDIT_TO_BE_CREATED_WATER_PUMP',
  REMOVE_TO_BE_CREATED_WATER_PUMP: 'REMOVE_TO_BE_CREATED_WATER_PUMP',
  EDIT_WATER_PUMP: 'EDIT_WATER_PUMP_TO_AC_CENTRAL',
  REMOVE_WATER_PUMP: 'REMOVE_WATER_PUMP_TO_AC_CENTRAL',
  ADD_COOLING_TOWER: 'ADD_COOLING_TOWER_TO_AC_CENTRAL',
  ADD_TO_BE_CREATED_COOLING_TOWER: 'ADD_TO_BE_CREATED_COOLING_TOWER',
  EDIT_COOLING_TOWER: 'EDIT_COOLING_TOWER_TO_AC_CENTRAL',
  EDIT_TO_BE_CREATED_COOLING_TOWER: 'EDIT_TO_BE_CREATED_COOLING_TOWER',
  REMOVE_COOLING_TOWER: 'REMOVE_COOLING_TOWER_TO_AC_CENTRAL',
  REMOVE_TO_BE_CREATED_COOLING_TOWER: 'REMOVE_TO_BE_CREATED_COOLING_TOWER',
  ADD_AIR_HANDLING_UNIT: 'ADD_AIR_HANDLING_UNIT_TO_AC_CENTRAL',
  ADD_TO_BE_CREATED_AIR_HANDLING_UNIT: 'ADD_TO_BE_CREATED_AIR_HANDLING_UNIT',
  REMOVE_AIR_HANDLING_UNIT: 'REMOVE_AIR_HANDLING_UNIT_TO_AC_CENTRAL',
  REMOVE_TO_BE_CREATED_AIR_HANDLING_UNIT: 'REMOVE_TO_BE_CREATED_AIR_HANDLING_UNIT',
  CLEAR_AC_CENTRAL: 'CLEAR_AC_CENTRAL'
};

export const clearErrorACCentral = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};

const ac_central_chiller_rel_converter = (item, key) => {
  const {
    quantity,
    central_air,
    ...entityOnly
  } = item;
  return {
    id: item.id * 1000,
    quantity: quantity,
    ac_central_id: central_air,
    [key]: entityOnly,
  }
};

const ac_central_converter = (ac_central) => {
  return {
    ...ac_central,
    chiller_list: ac_central.chiller_list.map(chiller => ac_central_chiller_rel_converter(chiller, 'chiller')),
    water_pump_list: ac_central.water_pump_list.map(wp => ac_central_chiller_rel_converter(wp, 'waterPump')),
    cooling_tower_list: ac_central.cooling_tower_list.map(ct => ac_central_chiller_rel_converter(ct, 'coolingTower')),
    fan_coil_list: ac_central.fan_coil_list.map(ahu => ac_central_chiller_rel_converter(ahu, 'ahu')),
  }
};

export const searchACCentralByText = (text, page) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  const sorted = withDefaultSort([]);
  const filtered = text;
  const isPublic = null;
  return searchACCentral(pageSize, page, sorted, filtered, isPublic);
};

export const searchACCentral = (pageSize, page, sorted, filtered, isPublic) => {
  return RestClient.request({
    method: 'get',
    url: Constants.API_AC_CENTRAL,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
        : null,
      is_public: isPublic,
    },
  });
};

export const listACCentral = (pageSize, page, sorted, filtered, isPublic) => {
  return {
    type: ACTION.LIST,
    payload: searchACCentral(pageSize, page, sorted, filtered, isPublic)
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const getACCentral = id => {
  return {
    type: ACTION.GET,
    payload: RestClient.request({
      method: 'get',
      url: `${Constants.API_AC_CENTRAL}${id}/`,
    })
    // FIXME: Just apply interim converter
    //   .then(data => ac_central_converter(data))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const createACCentral = (name, description, image, water_pump_list, chiller_list, cooling_tower_list, fan_coil_list) => {
  const formData = new FormData();
  formData.set('water_pump_list', JSON.stringify(water_pump_list));
  formData.set('chiller_list', JSON.stringify(chiller_list));
  formData.set('cooling_tower_list', JSON.stringify(cooling_tower_list));
  formData.set('fan_coil_list', JSON.stringify(fan_coil_list));
  if (name) formData.set('name', name);
  if (typeof description === 'string') formData.set('description', description);
  if (image) formData.set('image', image, `acct_${new Date().valueOf()}`);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_AC_CENTRAL,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editACCentral = (id, name, description, image) => {
  const formData = new FormData();
  if (name) formData.set('name', name);
  if (typeof description === 'string') formData.set('description', description);
  if (image) formData.set('image', image, `acct_${new Date().valueOf()}`);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_AC_CENTRAL}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteACCentral = id => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_AC_CENTRAL}${id}/`,
    })
      .then(() => ({ id }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const duplicateACCentral = (id, name) => {
  const data = { new_name: name };
  return {
    type: ACTION.DUPLICATE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_AC_CENTRAL}${id}/copy/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const addChillerToACCentral = (acCentralId, chillerId, quantity) => {
  const data = {
    ac_central_id: acCentralId,
    chiller_id: chillerId,
    quantity: quantity,
  };

  return {
    type: ACTION.ADD_CHILLER,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_AC_CENTRAL_CHILLER,
      data,
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const addToBeCreatedChiller = (quantity, chiller, tobeCreatedchillerarry) => {
  if (tobeCreatedchillerarry.length > 0 ){
    let existed_obj = tobeCreatedchillerarry.filter(rel => rel.chiller.id === chiller.id)
    if (existed_obj.length > 0){
      return {
        type: ACTION.ADD_TO_BE_CREATED_CHILLER,
        payload: Promise.reject({detail: "The chiller name: " + existed_obj[0].chiller.name + " is already added into list!"})
      };
    }
  }
  const data = {
    quantity: quantity,
    chiller: chiller,
  };

  return {
    type: ACTION.ADD_TO_BE_CREATED_CHILLER,
    payload: Promise.resolve(data),
  };
};

export const editChillerInACCentral = (acCentralChillerId, quantity) => {
  const data = {
    quantity,
  };

  return {
    type: ACTION.EDIT_CHILLER,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_AC_CENTRAL_CHILLER}${acCentralChillerId}/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editToBeCreatedChiller = (chillterId, quantity) => {
  const data = {
    id: chillterId,
    quantity: quantity,
  };

  return {
    type: ACTION.EDIT_TO_BE_CREATED_CHILLER,
    payload: Promise.resolve(data),
  };
};

export const removeChillerFromACCentral = (acCentralChillerId, acCentralId) => {
  return {
    type: ACTION.REMOVE_CHILLER,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_AC_CENTRAL_CHILLER}${acCentralChillerId}/`,
    })
      .then(() => ({ id: acCentralChillerId, ac_central_id: acCentralId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const removeToBeCreatedChiller = (chillerId) => {
  const data = {
    id: chillerId,
  };

  return {
    type: ACTION.REMOVE_TO_BE_CREATED_CHILLER,
    payload: Promise.resolve(data),
  };
};

export const addWaterPumpToACCentral = (acCentralId, waterPumpId, quantity) => {
  const data = {
    ac_central_id: acCentralId,
    water_pump_id: waterPumpId,
    quantity: quantity,
  };

  return {
    type: ACTION.ADD_WATER_PUMP,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_AC_CENTRAL_WATER_PUMP,
      data,
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const addToBeCreatedWaterPump = (quantity, water_pump, tobecreatedwaterpumparry) => {
  if (tobecreatedwaterpumparry.length > 0 ){
    let existed_obj = tobecreatedwaterpumparry.filter(rel => rel.water_pump.id === water_pump.id)
    if (existed_obj.length > 0){
      return {
        type: ACTION.ADD_TO_BE_CREATED_WATER_PUMP,
        payload: Promise.reject({detail: "The water pump name: " + existed_obj[0].water_pump.name + " is already added into list!"})
      };
    }
  }
  const data = {
    quantity: quantity,
    water_pump: water_pump
  };

  return {
    type: ACTION.ADD_TO_BE_CREATED_WATER_PUMP,
    payload: Promise.resolve(data)
  };
};

export const editWaterPumpInACCentral = (acCentralWaterPumpId, quantity) => {
  const data = {
    quantity,
  };

  return {
    type: ACTION.EDIT_WATER_PUMP,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_AC_CENTRAL_WATER_PUMP}${acCentralWaterPumpId}/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editToBeCreatedWaterPump = (waterPumpId, quantity) => {
  const data = {
    quantity: quantity,
    id: waterPumpId,
  };

  return {
    type: ACTION.EDIT_TO_BE_CREATED_WATER_PUMP,
    payload: Promise.resolve(data)
  };
};

export const removeWaterPumpFromACCentral = (acCentralWaterPumpId, acCentralId) => {
  return {
    type: ACTION.REMOVE_WATER_PUMP,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_AC_CENTRAL_WATER_PUMP}${acCentralWaterPumpId}/`,
    })
      .then(() => ({ id: acCentralWaterPumpId, ac_central_id: acCentralId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const removeToBeCreatedWaterPump = (waterPumpId) => {
  const data = {
    id: waterPumpId,
  };

  return {
    type: ACTION.REMOVE_TO_BE_CREATED_WATER_PUMP,
    payload: Promise.resolve(data)
  };
};

export const addCoolingTowerToACCentral = (acCentralId, coolingTowerId, quantity) => {
  const data = {
    ac_central_id: acCentralId,
    cooling_tower_id: coolingTowerId,
    quantity: quantity,
  };

  return {
    type: ACTION.ADD_COOLING_TOWER,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_AC_CENTRAL_COOLING_TOWER,
      data,
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const addToBeCreatedCoolingTower = (quantity, cooling_tower, tobecreatedcoolingtowerarry) => {
  if (tobecreatedcoolingtowerarry.length > 0 ){
    let existed_obj = tobecreatedcoolingtowerarry.filter(rel => rel.cooling_tower.id === cooling_tower.id)
    if (existed_obj.length > 0){
      return {
        type: ACTION.ADD_TO_BE_CREATED_COOLING_TOWER,
        payload: Promise.reject({detail: "The cooling tower name: " + existed_obj[0].cooling_tower.name + " is already added into list!"})
      };
    }
  }
  const data = {
    quantity: quantity,
    cooling_tower: cooling_tower
  };

  return {
    type: ACTION.ADD_TO_BE_CREATED_COOLING_TOWER,
    payload: Promise.resolve(data),
  };
};

export const editCoolingTowerInACCentral = (acCentralCoolingTowerId, quantity) => {
  const data = {
    quantity,
  };

  return {
    type: ACTION.EDIT_COOLING_TOWER,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_AC_CENTRAL_COOLING_TOWER}${acCentralCoolingTowerId}/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editToBeCreatedCoolingTower = (coolingTowerId, quantity) => {
  const data = {
    id: coolingTowerId,
    quantity: quantity,
  };

  return {
    type: ACTION.EDIT_TO_BE_CREATED_COOLING_TOWER,
    payload: Promise.resolve(data),
  };
};

export const removeCoolingTowerFromACCentral = (acCentralCoolingTowerId, acCentralId) => {
  return {
    type: ACTION.REMOVE_COOLING_TOWER,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_AC_CENTRAL_COOLING_TOWER}${acCentralCoolingTowerId}/`,
    })
      .then(() => ({ id: acCentralCoolingTowerId, ac_central_id: acCentralId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const removeToBeCreatedCoolingTower = (coolingTowerId) => {
  const data = {
    id: coolingTowerId,
  };
  return {
    type: ACTION.REMOVE_TO_BE_CREATED_COOLING_TOWER,
    payload: Promise.resolve(data),
  };
};

export const addAirHandlingUnitToACCentral = (acCentralId, ahuId) => {
  const data = {
    ac_central_id: acCentralId,
    fan_coil_id: ahuId,
  };

  return {
    type: ACTION.ADD_AIR_HANDLING_UNIT,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_AC_CENTRAL_AIR_HANDLING_UNIT,
      data,
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const addToBeCreatedAirHandlingUnit = (fan_coil, tobecreatedairhandlingarry) => {
  if (tobecreatedairhandlingarry.length > 0 ){
    let existed_obj = tobecreatedairhandlingarry.filter(rel => rel.fan_coil.id === fan_coil.id)
    if (existed_obj.length > 0){
      return {
        type: ACTION.ADD_TO_BE_CREATED_AIR_HANDLING_UNIT,
        payload: Promise.reject({detail: "The fan coil name: " + existed_obj[0].fan_coil.name + " is already added into list!"})
      };
    }
  }
  const data = {
    fan_coil: fan_coil
  };

  return {
    type: ACTION.ADD_TO_BE_CREATED_AIR_HANDLING_UNIT,
    payload: Promise.resolve(data),
  };
};

export const removeAirHandlingUnitFromACCentral = (acCentralAirHandlingUnitId, acCentralId) => {
  return {
    type: ACTION.REMOVE_AIR_HANDLING_UNIT,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_AC_CENTRAL_AIR_HANDLING_UNIT}${acCentralAirHandlingUnitId}/`,
    })
      .then(() => ({ id: acCentralAirHandlingUnitId, ac_central_id: acCentralId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const removeToBeCreatedAirHandlingUnit = (ahuId) => {
  const data = {
    id: ahuId,
  };
  return {
    type: ACTION.REMOVE_TO_BE_CREATED_AIR_HANDLING_UNIT,
    payload: Promise.resolve(data),
  };
};

export const searchACCentralAirHandlingUnitByText = (text, page = 0, excludeZoneId = null) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  const sorted = null;
  const filtered = text;
  const isPublic = null;
  return searchACCentralAirHandlingUnit(pageSize, page, sorted, filtered, isPublic, excludeZoneId);
};

export const searchACCentralAirHandlingUnit = (pageSize, page, sorted, filtered, isPublic, excludeZoneId = null) => {
  const zoneParams = excludeZoneId && { not__zone_id: excludeZoneId };
  return RestClient.request({
    method: 'get',
    url: Constants.API_AC_CENTRAL_AIR_HANDLING_UNIT,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
        : null,
      is_public: isPublic,
      ...zoneParams,
    },
  });
};

export const clearTobeCreatedACCENTRAL = () => {
  
  return {
    type: ACTION.CLEAR_AC_CENTRAL,
    payload: Promise.resolve()
  };
};



// WEBPACK FOOTER //
// ./src/redux/ac_central/ac_central_actions.js